module.exports = __webpack_public_path__ + "img/box-07.8aefbdbb.jpeg";